module.exports = __webpack_public_path__ + "static/assets/b4aa6720d2ef6b566356573a0fcea0af.png";